var React = require('react');

function IconoFB40px (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M40 20.0036C40 5.4856 35.245 0 20 0C4.75502 0 0 5.4856 0 20.0036C0 33.8133 4.30237 39.4504 17.843 39.9676C17.3837 39.928 16.9286 39.873 16.4782 39.8028V25.9497H11.4V20.2195H16.4782V15.8522C16.4782 10.8847 19.4626 8.13965 24.0328 8.13965C26.2203 8.13965 28.5094 8.52682 28.5094 8.52682V13.4052H25.986C23.5016 13.4052 22.7282 14.9346 22.7282 16.5026V20.2195H28.275L27.3883 25.9497H22.7282V39.8028C22.1371 39.8949 21.5382 39.9609 20.9322 40.0001C35.4396 39.7765 40 34.2214 40 20.0036Z","fill":"#4528B3"}));
}

IconoFB40px.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = IconoFB40px;

IconoFB40px.default = IconoFB40px;
